import { createAction } from '@reduxjs/toolkit'

const start = createAction('initLoader/start')
const finish = createAction('initloader/finish')

export default {
    start,
    finish
}
